var _circle, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTram3Backwheels(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 67,
    viewBox: "0 0 287 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.6836,
    cy: 34.0469,
    r: 27.5,
    fill: "black",
    stroke: "black",
    strokeWidth: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.8184,
    cy: 34.0469,
    r: 27.5,
    fill: "black",
    stroke: "#9AFF6B",
    strokeWidth: 10
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 254.049,
    cy: 32.8555,
    r: 27.5,
    fill: "black",
    stroke: "black",
    strokeWidth: 10
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.992,
    cy: 32.8555,
    r: 27.5,
    fill: "black",
    stroke: "#9AFF6B",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTram3Backwheels);
export default __webpack_public_path__ + "static/media/tram3-backwheels.02be7320fbbf28d9e3667850384de1b2.svg";
export { ForwardRef as ReactComponent };